import { MutationType } from '@tencent/slide-sdk-pb-model';
import { DataType } from '../../data';
import { BaseMutation } from '../base';
import { Rule } from '../base/mutation-rules';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidSetCommentPropertiesMutationData } from '../base/valid-mutation-data';

export class SetCommentPropertiesMutation extends BaseMutation<
    PresentationDataModel,
    IValidSetCommentPropertiesMutationData
> {
    public readonly type: MutationType = MutationType.SetCommentProperties;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.pageId) return;
        const { pageId, commentType, groupId, shapeId, anchorPosition, textAnchor } = this.data;
        const page = presentation.store.models.get(pageId, DataType.Slide);
        page?.store.patchData({
            commentGroupMap: {
                [groupId]: { commentType, shapeId, anchorPosition, textAnchor },
            },
        });
    }

    public invert(presentation: PresentationDataModel): [IValidSetCommentPropertiesMutationData] {
        const { pageId, groupId, commentType } = this.data;
        const page = presentation.store.models.get(pageId, DataType.Slide);
        const commentGroup = page?.store.commentGroupMap?.[groupId];
        return [
            {
                type: MutationType.SetCommentProperties,
                pageId,
                groupId,
                commentType: commentGroup?.commentType ?? commentType,
                shapeId: commentGroup?.shapeId,
                anchorPosition: commentGroup?.anchorPosition,
                textAnchor: commentGroup?.textAnchor,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, commentType, groupId, shapeId, anchorPosition, textAnchor } = this.data;
        // 删除形状/文字批注所在的形状时，anchorPosition会置会undefined，即默认到背景的右上角
        return Rule.every(
            () => Rule.page.should.exist(presentation, pageId),
            () => Rule.comment.groupId.should.exist(presentation, pageId, groupId),
            () => Rule.comment.commentType.should.exist(commentType),
            () => Rule.comment.anchorPosition.is.valid(anchorPosition),
            () => Rule.comment.shapeId.is.valid(commentType, shapeId),
            () => Rule.comment.textAnchor.is.valid(textAnchor),
        );
    }
}
